export const companyData = {
  name: "GSoftNet Studios",
  tagline: "Business Software Consultancy Excellence",
  
  story: `GSoftNet Studios was established and registered on 20th July 2019. It officially started its operations from January 2020 as a small business start-up providing Business Consultancy in Software Development. Throughout its establishment in the industry, it was able to achieve high-quality services to its customers. Its founder, Ally Mohamed, is looking forward to scale it to another level in order to accommodate its clients such as small and medium-sized enterprises across various parts of the United Republic of Tanzania.`,
  
  mission: `Our mission is to establish a bond and satisfied clients by providing good quality and on-time product & services. We want to make a significant change in the business industry with the help of innovative and creative technologies that help resolve our customer's problems. We will render most of our time in making relevant projects that fulfill our client's needs.`,
  
  vision: "To become the leading Business Software Consultancy firm in Tanzania, empowering businesses with innovative technology solutions.",
  
  director: {
    name: "Ally Mohamed Ismail",
    position: "Owner & Lead Software Developer",
    image: "/images/photo.png",
    responsibilities: "Lead Software Developer, Software Consultant",
    experience: "Over 10 years in IT field with five years in software development in different technologies & languages like C, C#, C++, Kotlin, Java, JavaScript, PHP, ASP.NET, Laravel, VueJS, RESTful API, HTML & CSS for Web applications, Desktop applications, Android Applications etc."
  },
  
  services: [
    {
      title: "System Development",
      description: "Custom software solutions including web applications, desktop applications, and mobile applications tailored to your business requirements.",
      icon: "Code"
    },
    {
      title: "Cloud Computing",
      description: "Scalable cloud infrastructure solutions to help your business grow efficiently and securely in the digital age.",
      icon: "Cloud"
    },
    {
      title: "System Support",
      description: "Comprehensive technical support and maintenance services to ensure your systems run smoothly 24/7.",
      icon: "Settings"
    },
    {
      title: "Business Consultation",
      description: "Expert consultation in Accounting packages like Sage 50, Sage 200 Evolution, and Payroll systems including VIP Premier Payroll.",
      icon: "Users"
    }
  ],
  
  testimonials: [
    {
      name: "Sarah Johnson",
      company: "TechFlow Solutions",
      content: "GSoftNet Studios delivered exceptional software solutions that transformed our business operations. Their expertise and dedication are unmatched.",
      rating: 5
    },
    {
      name: "Michael Chen",
      company: "Digital Innovations Ltd",
      content: "Professional service, on-time delivery, and excellent support. They truly understand business needs and deliver accordingly.",
      rating: 5
    },
    {
      name: "Amina Hassan",
      company: "East Africa Ventures",
      content: "The cloud computing solutions they provided helped us scale our operations efficiently. Highly recommended for any business.",
      rating: 5
    }
  ],
  
  contact: {
    email: "info@gsoftnet.systems",
    phone: "255713943842",
    address: "Dar es Salaam, Tanzania",
    website: "www.gsoftnet.systems",
    instagram: "https://www.instagram.com/gsoftnetstudios",
    facebook: "https://www.facebook.com/gsoftnetstudios",
  },
  
  stats: [
    { number: "50+", label: "Projects Completed" },
    { number: "100%", label: "Client Satisfaction" },
    { number: "10+", label: "Years Experience" },
    { number: "24/7", label: "Support Available" }
  ]
};